import $ from 'jquery';
import "flexslider";
import "@fancyapps/fancybox";


$(document).ready(function() {
    
    if ( $('.bulletin-board').length) {
        $('.bulletin-images.flexslider').flexslider({
          animation: "slide",
          controlNav: false,
          directionNav: true,
          touch: true,
          slideshow: false,
          start: function(item){
              slideCounter(item);
          },
          after: function(item){
              slideCounter(item);
          }
        });

        function slideCounter(item){
            var $sliderItemTotal =  item.find('.slider-item-total');
		    var $sliderItemCurrent =  item.find('.slider-item-current');
            $sliderItemCurrent.text(item.currentSlide + 1);
            $sliderItemTotal.text(item.find('.slides').find('li:not(.clone)').length);
        }
    }

    $('.bulletin-board .slides li:not(.clone) a.fancybox-media').fancybox({
        buttons: [
          "zoom",
          //"share",
          // "slideShow",
          //"fullScreen",
          //"download",
          "thumbs",
          "close"
        ],
        hideOnOverlayClick: true,
        hideOnContentClick: true,
        showCloseButton: true,
        transitionEffect: "slide",
        hash   : false,
        share  : false,
    });
}); 